var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"student-app"}},[_c('student-navbar'),_c('router-view',{attrs:{"user":_vm.getUser}}),_c('student-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }